import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class TopNavService {
  baseUrl = "https://predev.one-qms.com/oneqms-service-v1/oneqms";
  // baseUrl = "http://localhost:8080/oneqms";
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      'Cache-Control': 'no-cache'
    }),
  };

  moduleChildrens: any = [];
  selectedVal: any;
  constructor(private readonly http: HttpClient) { };

  userDefaultGroup() {
    return this.http.get(`${this.baseUrl}` + "/qmsUserDefaultGroup/getByRowNum");
  }

  usersGroupModules(groupId: any) {
    return this.http.get(`${this.baseUrl}` + "/qmsGrMoCuUsVw/" + groupId + "/getModuleList");
  }

  getDistinctModules() {
    return this.http.get(`${this.baseUrl}` + "/qmsGrMoCuUsVw/getDistinctModules");
  }

  getGroupList() {
    return this.http.get(`${this.baseUrl}` + "/qmsGrMoCuUsVw/getGroupList");
  }

  getDistinctGroupList() {
    return this.http.get(`${this.baseUrl}` + "/qmsGrMoCuUsVw/getDistinctGroups");
  }

  usersModuleGroupListDropdown(module: any) {
    return this.http.get(`${this.baseUrl}` + "/qmsGrMoCuUsVw/" + module + "/byModule1");
  }

  callSetDefaultGrouop(userDetails: any) {
    return this.http.post(`${this.baseUrl}` + "/qmsUserDefaultGroup/callSetDefaultGrouop", userDetails);
  }

  getUserDetailsForTrainingDashboard(userId?: any) {
    return this.http.get(`${this.baseUrl}/usersVw/getUserDetails`, { params: { ...(userId != null && { userId: userId }) } }
    );
  }
}
